module.exports = __webpack_public_path__ + "static/media/Inter-Regular.f67b0de3.otf";